export default __webpack_public_path__ + "f44107133f5f70e6dd1bfdc6f477122d.jpeg";